import { Button } from "@mui/joy";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import { PlanKey } from "../../components/task/payment/planTypes";
import {
  loadTossPayments,
  TossPaymentsPayment,
} from "@tosspayments/tosspayments-sdk";
import { v4 as uuidv4 } from "uuid";
import CustomModalOnlySmall from "../../components/common/CustomModalOnlySmall";
import { gtagConversion } from "../../utils/gtag";

export default function PromotionPaymentButton({
  selectedPlan,
}: {
  selectedPlan: PlanKey;
}) {
  const tossPaymentsClientKey = process.env.REACT_APP_TOSSPAYMENTS_CLIENT_KEY!!;
  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  const [tossPaymentsPayment, setTossPaymentsPayment] =
    useState<TossPaymentsPayment | null>();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const buttonText = "프로그램 결제하기";

  async function requestTossPayments() {
    if (tossPaymentsPayment) {
      try {
        await tossPaymentsPayment?.requestPayment({
          method: "CARD",
          amount: {
            currency: "KRW",
            value: 365000,
          },
          orderId: uuidv4(),
          orderName: `디스턴싱 100일 프로그램 (비회원 결제)`,
          successUrl:
            window.location.origin + "/toss-payments/promotion/success",
          failUrl: window.location.origin + "/promotion",
          // customerEmail:
          // customerName: paymentOrderState.customerName,
          card: {
            useEscrow: false,
            flowMode: "DEFAULT",
            useCardPoint: false,
            useAppCardOnly: false,
          },
        });
      } catch (error) {
        // 에러 처리하기
        console.error(error);
      }
    }
  }

  useEffect(() => {
    async function fetchTossPaymentsPayment() {
      if (tossPaymentsClientKey) {
        const tossPayments = await loadTossPayments(tossPaymentsClientKey);
        const payment = tossPayments.payment({
          customerKey: `ck_${uuidv4()}`,
        });

        setTossPaymentsPayment(payment);
      }
    }

    fetchTossPaymentsPayment();
  }, [tossPaymentsClientKey]);

  const handlePaymentRequest = () => {
    setModalOpen(false);

    ReactPixel.track("StartTrial", {
      value: "0.00",
      currency: "KRW",
      predicted_ltv: "0.00",
    });

    gtagConversion("GqX8CIXO358bEM2r2Lso");

    requestTossPayments();
  };

  return (
    <>
      <Button
        loading={isLoading}
        onClick={() => setModalOpen(true)}
        size={"lg"}
        color={"primary"}
        sx={{
          width: "100%",
          fontWeight: 700,
        }}
      >
        {buttonText}
      </Button>
      <CustomModalOnlySmall
        open={isModalOpen}
        onClose={handlePaymentRequest}
        title={"결제 시\n" + "이메일을 꼭 적어주세요!"}
        subtitle={"적어주신 이메일로 이용방법을 안내해 드립니다."}
        actions={[
          {
            label: "확인",
            variant: "Solid",
            onClick: () => handlePaymentRequest(),
          },
        ]}
      />
    </>
  );
}
